import angular from 'angular';

import NotificationComponent from './notification.cmpt';

export default angular
    .module('application.component.notifications.component.notification', [])
    .component(NotificationComponent.selector, NotificationComponent);



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/notification/index.js